<template>
  <div :id="`completion-card-${detail?.checklistId}`" class="tw-flex">
    <div
      :class="[
        'tw-bg-[#FCFCFC] tw-max-h-[112px] tw-min-h-[112px] tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-l-md tw-border-solid tw-border-[#EFF0F1]',
        classStyleContent,
      ]"
    >
      <div class="tw-flex tw-justify-between tw-w-full">
        <div
          class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-[600] tw-leading-[130%] title"
        >
          {{ getComponentUiText("app-component-assessment-title-status-1") }}
        </div>
        <div>
          <AssessmentChecklistStatusTag
            :id="`checklist-status-tag-${isAssessmentDetail ? 'detail' : ''}-${
              detail?.checklistId
            }`"
            :checklist-status="checklistInforDetail.checklistStatus"
            :checklist-status-id="checklistInforDetail.checklistStatusId"
            :is-loading="
              props.isAssessmentDetail ? false : isChecklistInforDetailLoading
            "
          />
          <b-popover
            :target="`checklist-status-tag-${
              isAssessmentDetail ? 'detail' : ''
            }-${detail?.checklistId}`"
            triggers="hover"
            placement="top-start"
            custom-class="custom-actions-popover"
            :offset="8"
            :delay="{
              show: 0,
              hide: 100,
            }"
            @show="true"
          >
            <div
              class="tw-px-[5px] tw-py-[3px] tw-bg-[#E4F1FF] tw-text-[#211F58] tw-rounded-[4px] tw-text-[11px] tw-font-medium tw-font-[Poppins]"
            >
              {{ convertUTCTimeToLocalTime(detail?.checklistStatusDate) }}
              {{
                detail?.checklistStatusNotes
                  ? `: ${detail?.checklistStatusNotes}`
                  : ""
              }}
            </div>
          </b-popover>
        </div>
      </div>
      <div class="tw-flex tw-flex-col tw-w-full">
        <div class="tw-flex tw-justify-between tw-w-full">
          <div
            class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
          >
            {{
              getComponentUiText("app-component-assessment-title-progress-1")
            }}
          </div>
          <div
            v-if="
              isChecklistMetricsCompletionLoading && !props.isAssessmentDetail
            "
            class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
          ></div>
          <div v-else class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
            {{
              props.isAssessmentDetail
                ? props.checklistCompletionProps.checklistCompletion
                : checklistMetricsCompletion.checklistCompletion
            }}/{{
              props.isAssessmentDetail
                ? props.checklistCompletionProps.checklistCompletionMax
                : checklistMetricsCompletion.checklistCompletionMax
            }}
            <span class="tw-text-[#878787] tw-font-[500]"
              >{{ percentProgress }}%</span
            >
          </div>
        </div>

        <div class="tw-flex tw-justify-between tw-w-full">
          <div
            class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
          >
            {{
              getComponentUiText(
                "app-component-assessments-question-type-2-icon-tooltip-score-1",
              )
            }}
          </div>
          <div
            v-if="
              isChecklistMetricsCompletionLoading && !props.isAssessmentDetail
            "
            class="custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
          ></div>
          <div
            v-else
            class="tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
          >
            <div class="tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]">
              {{
                props.isAssessmentDetail
                  ? Math.round(+props.checklistScoreDetail?.checklistScore)
                  : Math.round(+checklistCompletion?.checklistScore)
              }}/{{
                props.isAssessmentDetail
                  ? Math.round(+props.checklistScoreDetail?.checklistScoreMax)
                  : Math.round(+checklistCompletion?.checklistScoreMax)
              }}
              <span class="tw-text-[#878787] tw-font-[500]"
                >{{
                  props.isAssessmentDetail
                    ? (
                        props.checklistScoreDetail?.checklistScorePcnt * 100
                      ).toFixed(1)
                    : (checklistCompletion?.checklistScorePcnt * 100).toFixed(
                        1,
                      )
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="isShowRadial"
      :class="[
        'tw-p-[20px] tw-bg-[#FCFCFC] tw-max-h-[112px] tw-max-w-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
        classStyleIcon,
      ]"
    >
      <div
        v-if="isChecklistMetricsCompletionLoading && !props.isAssessmentDetail"
        class="custom-global-skeleton-pulse tw-w-[72px] tw-h-[72px] tw-rounded-[50%]"
      ></div>
      <RadialProgressBar
        v-else
        class="d-inline"
        :total-steps="100"
        :completed-steps="percentProgress"
        :is-hide-progress="true"
        outer-stroke-color="#48A0FF"
      />
    </div>
    <div
      v-show="!isShowRadial"
      :class="[
        'tw-flex tw-items-center tw-justify-center tw-p-[20px] tw-bg-[#ffffff] tw-max-w-[112px] tw-max-h-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
        classStyleIcon,
      ]"
    >
      <div
        class="tw-w-[72px] tw-h-[72px] tw-flex tw-items-center tw-justify-center tw-text-[30px] tw-font-[600]"
        :class="`tw-text-[${
          TEXT_COLOR_WITH_GRADE_SCORE[
            generateGradeScoreWithCompletedScore(Number(percentScore))
          ]
        }]`"
      >
        {{ generateGradeScoreWithCompletedScore(Number(percentScore)) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import { ComputedRef, computed } from "vue";
import {
  TEXT_COLOR_WITH_GRADE_SCORE,
  generateGradeScoreWithCompletedScore,
} from "@/services/assessment";
import store from "@/store";
import { IChecklistMetricsCompletion } from "@/interfaces/assessments/IAssessmentDetails";
import { IChecklistInfoDetail } from "@/interfaces/assessments/IAssessmentDetails";
import AssessmentChecklistStatusTag from "../assessment/assessmentChecklistStatusTag.vue";
import { CHECKLISTSTATUS } from "@/utils/constants";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";

const props = defineProps({
  isAssessmentDetail: {
    type: Boolean,
    required: false,
    default: false,
  },
  detail: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  checklistCompletionProps: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  checklistScoreDetail: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  statusDetail: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  classStyleContent: {
    type: String,
    default: "",
  },
  classStyleIcon: {
    type: String,
    default: "",
  },
});

const checklistCompletion = computed(
  () => store.state.Assessment.overviewCardData?.completionCard,
);

const checklistMetricsCompletion: ComputedRef<IChecklistMetricsCompletion> =
  computed(() => store.getters["Assessment/getChecklistMetricsCompletion"]);

const checklistInforDetail: ComputedRef<IChecklistInfoDetail> = computed(() => {
  if (props.isAssessmentDetail) {
    const assessment = store.getters["Assessment/getChecklistInforDetailById"](
      props.detail?.checklistId,
    );
    return { ...props.detail, ...assessment };
  }
  return store.getters["Assessment/getChecklistInforDetail"];
});

const isShowRadial = computed(() => {
  return props.isAssessmentDetail
    ? props.statusDetail.checklistStatusId !== CHECKLISTSTATUS.DONE
    : checklistInforDetail.value.checklistStatusId !== CHECKLISTSTATUS.DONE;
});

const percentProgress = computed(() => {
  return props.isAssessmentDetail
    ? props.checklistCompletionProps.checklistCompletionPcnt
    : parseFloat(
        (
          checklistMetricsCompletion.value.checklistCompletionPcnt * 100
        ).toFixed(2),
      );
});

const percentScore = computed(() => {
  const score = props.isAssessmentDetail
    ? props.checklistScoreDetail.checklistScorePcnt
    : checklistCompletion.value.checklistScorePcnt;
  return (score * 100).toFixed(2);
});

const isChecklistInforDetailLoading = computed(() => {
  return Object.keys(checklistInforDetail.value).length === 0;
});

const isChecklistMetricsCompletionLoading = computed(() => {
  return Object.keys(checklistMetricsCompletion.value).length === 0;
});
</script>

<style>
:deep(.custom-actions-popover .popover-arrow) {
  height: 7px;
  width: 7px;
  background-color: #fff;
  transform: rotate(45deg);
}

:deep(.custom-actions-popover.bs-popover-bottom) {
  margin-top: unset;
  max-width: 100%;
  font-family: Poppins;
  .popover-arrow {
    top: -4px;
  }
}

:deep(.custom-actions-popover.bs-popover-top) {
  max-width: 100%;
  font-family: Poppins;
  .popover-arrow {
    bottom: -4px;
  }
}

:deep(.custom-actions-popover .popover-arrow)::before,
:deep(.custom-actions-popover .popover-arrow)::after {
  display: none !important;
}

.bs-popover-top > .popover-arrow::after {
  border-top-color: #e4f1ff !important;
}
</style>
